import React from "react";
import PropTypes from "prop-types";
import Modal from "Util/Modal";
import contractFragments from "../../Queries/graphql/contractFragments";
import ContractRenderer from "./ContractRenderer";
import ContractList from "./ContractList";
import useModal from "./useModal";

const NewOrderModal = ({ contracts, currentUser }) => {
  const { isOpen, toggleModal, closeModal } = useModal();
  const buttonText = "Add Manual Order";
  
  // Sort contracts by contract code
  const sortedContracts = contracts.toSorted((a, b) =>
    a.contractCode.localeCompare(b.contractCode)
  );

  // Single contract case
  if (sortedContracts.length === 1) {
    return (
      <ContractRenderer
        contract={sortedContracts[0]}
        buttonText={buttonText}
        onClose={closeModal}
        currentUser={currentUser}
        cssClass="button primary"
      />
    );
  }

  // Multiple contracts case
  return (
    <React.Fragment>
      <button className="button primary" onClick={toggleModal}>
        {buttonText}
      </button>
      {isOpen && (
        <Modal
          show={isOpen}
          onClose={toggleModal}
          header="Contract for the new order"
          className="draft-order-modal"
          renderFooter={() => (
            <a onClick={toggleModal} className="button button--back">
              Cancel
            </a>
          )}
        >
          <ContractList
            contracts={sortedContracts}
            onContractSelect={closeModal}
            currentUser={currentUser}
          />
        </Modal>
      )}
    </React.Fragment>
  );
};

NewOrderModal.propTypes = {
  contracts: PropTypes.arrayOf(contractFragments.object).isRequired,
  currentUser: PropTypes.object
};

export default NewOrderModal;
